import SafeMarkdown from '../../../libs/SafeMarkdown';
import React from 'react';
import styles from '../mockInterview.module.scss';
import MockInterviewEvaluationBlock from './MockInterviewEvaluationBlock';
import MockInterviewDialogChat from './MockInterviewDialogChat';

const MockInterviewTurnDetail = ({ turn, adviceRules, metricSchemas, interviewId, onRetryEvaluate, retrying }) => {
    if (!turn) {
        return null;
    }

    const hasDialog = Array.isArray(turn.dialog) && turn.dialog.length > 0;

    return (
        <div className={'p20'}>
            <div className={'card'}>
                <div className={'card-body'}>
                    <div className="quiz-preview animChilds">
                        <div className={styles.questionItemRow}>
                            <div className="quiz-submit-title no-select">
                                <SafeMarkdown source={turn.question}/>
                            </div>
                        </div>
                    </div>
                    {true && <hr/>}
                    {!hasDialog && <div className={`quiz-answer-it no-select`}>
                        <SafeMarkdown source={turn.transcript || '—'}
                        />
                    </div>}
                    {hasDialog && <MockInterviewDialogChat dialog={turn.dialog} mainQuestion={turn.question}/>}
                </div>
            </div>
            <MockInterviewEvaluationBlock
                key={turn.question_id}
                evaluation={turn.evaluate}
                adviceRules={adviceRules}
                metricSchemas={metricSchemas}
                interviewId={interviewId}
                evaluateId={turn.evaluateId}
                evaluateExplain={turn.evaluateExplain}
                evaluateStatus={turn.evaluateStatus}
                retrying={retrying}
                audioLost={turn.audioLost}
                onRetry={onRetryEvaluate
                    ? () => onRetryEvaluate(turn.question_id, { textOnly: !!turn.audioLost })
                    : null}
            />
        </div>
    );
};

export default MockInterviewTurnDetail;
